import { ProgramCreationComponent } from './programs/programCreation/programCreation.component';
import { VariableCreationComponent } from './intentManager/variableCreation/variable-creation.component';
import { IntentListComponent } from './intentManager/intent-list/intent-list.component';
import { WctHighlightEditorComponent } from './foundations-webct2-palette/components/wct-highlight-editor/wct-highlight-editor.component';
import { InvoiceComponent } from './customComponents/print/invoice/invoice.component';
import { SuperherosListComponent } from './superheros/superheros-list/superheros-list.component';


import { WctExternalComponent } from './wct-external/wct-external.component';

import { WctPageComponent } from './foundations-webct2-palette/components/wct-page/wct-page.component';
import { WctStartComponentsComponent } from './foundations-webct2-palette/components/wct-start-components/wct-start-components.component';
import { WctHeaderComponent } from './foundations-webct2-palette/components/wct-header/wct-header.component';
import { WctFooterComponent } from './foundations-webct2-palette/components/wct-footer/wct-footer.component';

import { WctTabsComponent } from './foundations-webct2-palette/components/wct-tabs/wct-tabs.component';
import { WctTabsContentComponent } from './foundations-webct2-palette/components/wct-tabs-content/wct-tabs-content.component';


import { WctFilterComponent } from './foundations-webct2-palette/components/wct-filter/wct-filter.component';
import { WctFieldsFormatComponent } from './foundations-webct2-palette/components/wct-fields-format/wct-fields-format.component';

import { WctTableComponent } from './foundations-webct2-palette/components/wct-table/wct-table.component';
import { WctTableOptionsComponent } from './foundations-webct2-palette/components/wct-table/wct-table-options/wct-table-options.component';
import { WctPaginationComponent } from './foundations-webct2-palette/components/wct-pagination/wct-pagination.component';
import { WctAlertComponent } from './foundations-webct2-palette/components/wct-alert/wct-alert.component';
import { WctButtonsComponent } from './foundations-webct2-palette/components/wct-buttons/wct-buttons.component';
import { WctNavbarComponent } from './foundations-webct2-palette/components/wct-navbar/wct-navbar.component';
import { WctSideNavbarComponent } from './foundations-webct2-palette/components/wct-side-navbar/wct-side-navbar.component';
import { WctNavbarMenuComponent } from './foundations-webct2-palette/components/wct-navbar-menu/wct-navbar-menu.component';
import { WctBreadcrumbComponent } from './foundations-webct2-palette/components/wct-breadcrumb/wct-breadcrumb.component';
import { WctLoadingComponent } from './foundations-webct2-palette/components/wct-loading/wct-loading.component';
import { WctLabelComponent } from './foundations-webct2-palette/components/wct-label/wct-label.component';
import { WctTagsComponent } from './foundations-webct2-palette/components/wct-tags/wct-tags.component';
import { CustomSideMenuComponent } from './customComponents/custom-side-menu/custom-side-menu.component';
import { IxsLoginComponent } from './customComponents/ixs-login/ixs-login.component';
import { CheckIxsExistenceComponent } from './customComponents/check-ixs-existence/check-ixs-existence.component';
import { VideoComponent } from './customComponents/video/video.component';
import { CustomLogoutComponent } from './customComponents/custom-logout/custom-logout.component';
import { LabelStartComponent } from './customComponents/labelStartComponent/labelStartPopUp.component';
import { SlidingNavBarComponent } from './customComponents/sliding-nav-bar/sliding-nav-bar.component';
import { WctCardsComponent } from './foundations-webct2-palette/components/wct-cards/wct-cards.component';
import { TuplelistCustomComponent } from './customComponents/tuplelistCustomComponent/tuplelist.custom.component';
import { TextEditorComponent } from './customComponents/text-editor/text-editor.component';
import { AnswersPreviewComponent } from './customComponents/answers-preview/answers-preview.component';

import { ProfilePictureComponent } from './customComponents/profile-picture/profile-picture.component';
import { InlineImageComponent } from './customComponents/inline-image/inline-image.component';
import { InlineMemberIdentificationComponent } from './customComponents/inline-member-identification/inline-member-identification.component';
import { UploadImages } from './customComponents/uploadImages/uploadImages.component';
import { WctTupleListComponent } from './foundations-webct2-palette/components/wct-tuple-list/wct-tuple-list.component';
import { WctTupleListComponentOriginalValue} from './customComponents/wct-tuple-list-originalvalue/wct-tuple-list-originalvalue.component';
import { WctModalComponent } from './foundations-webct2-palette/components/wct-modal/wct-modal.component';
import { WctNotificationComponent } from './foundations-webct2-palette/components/wct-notification/wct-notification.component';

import { WctDatepickerIntervalComponent } from './foundations-webct2-palette/components/wct-datepicker-interval/wct-datepicker-interval.component';
import { WctDatepickerComponent } from './foundations-webct2-palette/components/wct-datepicker/wct-datepicker.component';
import { WctUploadComponent } from './foundations-webct2-palette/components/wct-upload/wct-upload.component';
import { WctFileDownloadComponent } from './foundations-webct2-palette/components/wct-file-download/wct-file-download.component';

import { StripeCard } from './customComponents/stripe/stripe-card.component';
import { StripeCardList } from './customComponents/stripe/stripe-card-list.component';
import { PrintComponent } from './customComponents/print/print.component';

import { CustomTagInputComponent } from './customComponents/custom-tag-input/custom-tag-input.component';
import { CustomMentionsComponent } from './customComponents/custom-mentions/custom-mentions.component';
import { PrintLayoutComponent } from './customComponents/print/print-layout/print-layout.component';
import { CopyclipboardComponent } from './customComponents/copyclipboard/copyclipboard.component';
import { IntentVariablesComponent } from './intentManager/intent-variables/intent-variables.component';
import { GenericActionButtonComponent } from './customComponents/genericActionButton/generic-action-button.component';
import { IntentCreationComponent } from './intentManager/intentCreation/intent-creation.component';
import { MainIntentComponent } from './intentManager/main-intent-component/main-intent.component';
import { TourStartComponent } from './customComponents/tour-start/tour-start.component';


import { TestCreationComponent } from './testManager/testCreation/test-creation.component';
import { MainTestComponent } from './testManager/main-test-component/main-test.component';
import { TestListComponent } from './testManager/test-list/test-list.component';
import { TestVariablesComponent } from './testManager/test-variables/test-variables.component';
import { MainTestSetComponent } from './testManager/main-testSet-component/main-testSet.component';
import { TestSetListComponent } from './testManager/testSet-list/testSet-list.component';


export const DECLARATIONS_V2: any[] = [
  WctExternalComponent,
  WctPageComponent,
  WctStartComponentsComponent,
  WctHeaderComponent,
  WctFooterComponent,
  WctTabsComponent,
  WctTabsContentComponent,
  WctFilterComponent,
  WctFieldsFormatComponent,
  WctTableComponent,
  WctTableOptionsComponent,
  WctAlertComponent,
  WctButtonsComponent,
  WctNavbarComponent,
  WctSideNavbarComponent,
  WctNavbarMenuComponent,
  WctBreadcrumbComponent,
  WctLoadingComponent,
  WctLabelComponent,
  WctTagsComponent,
  CustomSideMenuComponent,
  IxsLoginComponent,
  CheckIxsExistenceComponent,
  VideoComponent,
  CustomLogoutComponent,
  LabelStartComponent,
  WctCardsComponent,
  TuplelistCustomComponent,
  TextEditorComponent,
  AnswersPreviewComponent,
  ProfilePictureComponent,
  InlineImageComponent,
  InlineMemberIdentificationComponent,
  StripeCard,
  StripeCardList,
  UploadImages,
  WctTupleListComponent,
  WctTupleListComponentOriginalValue,
  WctModalComponent,
  WctNotificationComponent,
  SlidingNavBarComponent,
  CustomTagInputComponent,
  CustomMentionsComponent,
  PrintComponent,
  PrintLayoutComponent,
  InvoiceComponent,
  CopyclipboardComponent,
  WctDatepickerComponent,
  WctDatepickerIntervalComponent,
  WctPaginationComponent,
  WctUploadComponent,
  WctFileDownloadComponent,
  WctHighlightEditorComponent,
  IntentListComponent,
  IntentVariablesComponent,
  GenericActionButtonComponent,
  TourStartComponent,
  IntentCreationComponent,
  VariableCreationComponent,
  MainIntentComponent,
  SuperherosListComponent,
  ProgramCreationComponent,
  MainTestComponent,
  TestListComponent,
  TestVariablesComponent,
  TestCreationComponent,
  MainTestSetComponent,
  TestSetListComponent
];
export const EXPORTS_V2: any[] = [
  WctPageComponent,
  WctStartComponentsComponent,
  WctHeaderComponent,
  WctFooterComponent,
  WctTabsComponent,
  WctTabsContentComponent,
  WctFilterComponent,
  WctFieldsFormatComponent,
  WctTableComponent,
  WctTableOptionsComponent,
  WctAlertComponent,
  WctButtonsComponent,
  WctNavbarComponent,
  WctSideNavbarComponent,
  WctNavbarMenuComponent,
  WctBreadcrumbComponent,
  WctLoadingComponent,
  WctLabelComponent,
  WctTagsComponent,
  WctCardsComponent,
  TuplelistCustomComponent,
  TextEditorComponent,
  ProfilePictureComponent,
  InlineImageComponent,
  InlineMemberIdentificationComponent,
  StripeCard,
  StripeCardList,
  UploadImages,
  WctTupleListComponent,
  WctTupleListComponentOriginalValue,
  WctModalComponent,
  WctNotificationComponent,
  SlidingNavBarComponent,
  CustomTagInputComponent,
  CustomMentionsComponent,
  PrintComponent,
  PrintLayoutComponent,
  InvoiceComponent,
  CopyclipboardComponent,
  WctDatepickerComponent,
  WctDatepickerIntervalComponent,
  WctPaginationComponent,
  WctUploadComponent,
  WctFileDownloadComponent,
  WctHighlightEditorComponent,
  IntentListComponent,
  IntentVariablesComponent,
  GenericActionButtonComponent,
  TourStartComponent,
  IntentCreationComponent,
  VariableCreationComponent,
  MainIntentComponent,
  ProgramCreationComponent,
  MainTestComponent,
  TestListComponent,
  TestVariablesComponent,
  TestCreationComponent,
  MainTestSetComponent,
  TestSetListComponent
];
